import * as types from "../types/systemSettings"

const initialState = {
  clientName: ""
}

const systemSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SYSTEM_SETTINGS:
      return { ...state, ...action.data }
    case types.SET_SYSTEM_CLIENTNAME:
      return { ...state, clientName: action.clientName }

    case types.UPDATE_SYSTEM_SETTINGS:
      return {
        ...state,
        ...action.newSystemSettings
      }
    case types.CLEAR_SYSTEM_CLIENTNAME:
      return {
        clientName: ""
      }
    default:
      return state
  }
}

export default systemSettingsReducer